import './modules/polyfills';
import copy from './modules/translations.json';
import { getParameterByName, loadingTemplate, isTouchDevice, getRegionContactMail, jQueryParseMailLink, adaptGeneralInfoToRegion } from './modules/utils';
import { getLabCardTemplate } from './modules/labCardTemplate';
import { googleApiGeocoding } from './modules/geolocation';
import { urlBiomarinContactForm } from './modules/constants';
import { 
  dispatchAnalytics_countrySelection,
  dispatchAnalytics_disclaimerAgree,
  dispatchAnalytics_labFeaturePopupMobile,
  dispatchAnalytics_labFeaturePopupHover,
  dispatchAnalytics_CTA_stayInformed,
  dispatchAnalytics_CTA_visitSite

} from './modules/analytics';

import { initializeReadMore as labsDisclaimerReadMore } from './modules/readMore';

const pageSlugs = {
  mainPage: 'cln2-main',
  labListing: 'cln2-lab-listing'
}

jQuery(document).ready(function () {

  googleApiGeocoding();

  jQuery('#CTA_stayInformed').on('click', dispatchAnalytics_CTA_stayInformed);
  jQuery('#CTA_visitSite').on('click', dispatchAnalytics_CTA_visitSite);

  if(~window.location.href.indexOf(pageSlugs.mainPage) ) {
    labsDisclaimerReadMore();
  }

  /* chosen() enables additional styling / functionality for select country element */
  $(function () {
    $(".chzn-select").chosen();
  });

  jQuery(".country-select__submit").click(function(){
    const countryCode = jQuery(".chzn-select").val();
    const countryName = document.querySelector('a.chosen-single').textContent.trim();
    dispatchAnalytics_countrySelection(countryCode, countryName);  
  })

  

  const otherCountriesInfoElement = jQuery('.other-countries-info-container').clone();
  const genericContactInfoElement = jQuery('.other-countries-info').clone();
  otherCountriesInfoElement.removeClass('hidden');

  const searchCountryInput = jQuery(".country-select__dropdown").find("select");
  const searchCountrySubmit = jQuery(".country-select__submit").not(".country-select__submit--main-page").not(".country-select__submit--lab-listing");
  const labResultsDiv = jQuery(".lab-list");

  const searchCountrySubmit_labListing = jQuery(".country-select__submit--lab-listing");

  const noLabsInfo = 'For information on diagnostic laboratory testing, please contact your local pediatric neurologist or metabolic specialist. Alternatively, please contact BioMarin Medical Information at ';

  const disclaimerOverlay = jQuery(".labs-disclaimer__overlay");
  const disclaimerAcceptElement = jQuery(".cln2btn--labs-disclaimer-agree").not(".cln2btn--labs-disclaimer-agree-main-page");
  const disclaimerCancelElement = jQuery(".labs-disclaimer__close-icon");

  function showLabsDisclaimer() {
    disclaimerOverlay.addClass('show');

    const countryCode = jQuery(".chzn-select").val();
    if(countryCode===null){
      return;
    }
    const countryName = document.querySelector('a.chosen-single').textContent.trim();
    dispatchAnalytics_countrySelection(countryCode, countryName);
      
    jQuery('body').addClass('labs-disclaimer-active');
  }
  function hideLabsDisclaimer() {
    disclaimerOverlay.removeClass('show');
    jQuery('body').removeClass('labs-disclaimer-active');
  }

  function onAcceptDisclaimer() {
    hideLabsDisclaimer();
    searchLabs();
  }

  function redirectToLabListing() {
    hideLabsDisclaimer();

    const countryCode = jQuery(".chzn-select").val();
    dispatchAnalytics_disclaimerAgree(countryCode);
    const {mainPage, labListing} = pageSlugs;
    const labListingUrl = window.location.href.replace(mainPage, labListing)+`?country=${countryCode}`;

    // TODO replace with proper solution for persisting dataLayer
    //window.sessionStorage.setItem('dataLayer', JSON.stringify(window.dataLayer));

    window.location.href = labListingUrl;
  }

  searchCountrySubmit.on("click", showLabsDisclaimer.bind(this));
  disclaimerCancelElement.on('click', hideLabsDisclaimer.bind(this));
  disclaimerAcceptElement.on("click", onAcceptDisclaimer.bind(this));

  
  /* USE CASE: SEPARATE PAGES */
  const disclaimerAcceptElement_mainPage = jQuery(".cln2btn--labs-disclaimer-agree-main-page");
  const searchCountrySubmit_mainPage = jQuery(".country-select__submit--main-page");

  // On submission in lab listing page, submit button shows disclaimer
  searchCountrySubmit_mainPage.on("click", showLabsDisclaimer.bind(this));
  // On accepting disclaimer, redirects to lab listing page
  disclaimerAcceptElement_mainPage.on("click", redirectToLabListing.bind(this));

  // On submission in lab listing page, submit button directly retrieves list of labs
  searchCountrySubmit_labListing.on("click", searchLabs.bind(this));

  let allEnabledLabFeatures;

  const handleFeaturePopup = (e) => {
    const element = e.currentTarget;
    const currentPop = element.querySelector('.popuptext');
    currentPop.classList.toggle("show");

    allEnabledLabFeatures.forEach(elem => {
      if (elem !== element) 
      {
        elem.querySelector('.popuptext').classList.remove("show");
      }
    })
  };

  function searchLabs() {
    const countryCode = jQuery(".chzn-select").val();
    const countryName = document.querySelector('a.chosen-single').textContent.trim();
    
    if(searchCountryInput.val()===null){
      return
    }

    //dispatchAnalytics_countrySelection(countryCode, countryName);

    jQuery(labResultsDiv).empty();
    jQuery(labResultsDiv).html(loadingTemplate);

    const selectedCountryLabel = document.querySelector('a.chosen-single').textContent.trim();
    
    
    jQuery.ajax({
      beforeSend: (xhr) => {
        xhr.setRequestHeader("X-WP-Nonce", hcpData.nonce);
      },
      url:
        hcpData.root_url +
        "/wp-json/labs/v1/findlabsbycountry?term=" +
        searchCountryInput.val(),
      type: "GET",
      success: (response) => {
        if(typeof response === "string"){
          response = JSON.parse(response.trim());
        }

        const countryInfo = response.selectedCountryInfo[0];
        if (!countryInfo) {
          jQuery(labResultsDiv).html('');
          throw new Error('No country found for the requested search.');
        }
        const knownRegion = countryInfo.region && countryInfo.region !== 'OTHER';
        const labCount = response.labs.length;
        const showingLabsLabel =  labCount === 1 ? 
          copy.lab_results_header_singular : 
          copy.lab_results_header.replace(':labCount', labCount);

        let noResultsHtml = otherCountriesInfoElement.prop('outerHTML');
        let genericInfoTemplate = `
          <div class="other-countries-info">
            <div class="other-countries-info__title">
              ${copy.latam_countries_info}
              <a target="_blank" href="${urlBiomarinContactForm}" class="cln2-link">${copy.latam_countries_info_link_label}</a>.
            </div>
          </div>
        `;
     
        if (knownRegion) {
          noResultsHtml = `<p>${noLabsInfo} ${getRegionContactMail(countryInfo.region)}.</p>`;
        }

        jQuery([document.documentElement, document.body]).animate({
            scrollTop: jQuery('.country-select__container').offset().top
        }, 700);

        jQuery(labResultsDiv).html(`

          <div class="row">
            <div class="one-third">
            ${ countryInfo.region !== 'OTHER' ? `
              <h2 class="lab-list__header">
                <span class="lab-list__header--highlighted"> ${selectedCountryLabel}: </span>
                 ${showingLabsLabel}
              </h2>`
              : ''
            }
            ${countryInfo.region === 'LATAM' ? genericInfoTemplate : ''}

              ${
                !response.labs.length ? noResultsHtml : ''
              }
                ${response.labs
                  .map(
                    (item) => getLabCardTemplate(item, countryInfo.region)
                  )
                  .join("")}
            </div>
          </div>
      
          `);

         allEnabledLabFeatures = document.querySelectorAll('.lab-item__feature:not(.lab-item__feature--disabled)');
          if (isTouchDevice()) {
            allEnabledLabFeatures.forEach((element) => {
              element.addEventListener('click', handleFeaturePopup);
              element.addEventListener('click', dispatchAnalytics_labFeaturePopupMobile);
            });
          } else {
            allEnabledLabFeatures.forEach((element) => {
              element.addEventListener('mouseenter', (e) => dispatchAnalytics_labFeaturePopupHover(e, 'random'));
            });
          }

          if (countryInfo.region == 'LATAM') {
            adaptGeneralInfoToRegion('LATAM');
          } 
          jQuery('.lab-item__header-title').filter(jQueryParseMailLink);

      },
      error: (error) => {
        jQuery(labResultsDiv).html('');
        console.log(
          "There was a problem retrieving the list of laboratories.",
          error
        );
      },
    });
  }
  /*
  // TODO replace with proper solution for persisting dataLayer
  // Delete stored dataLayer if user lands on main page (beginning of the flow)
  if(~window.location.href.indexOf(pageSlugs.mainPage)) {
    window.sessionStorage.removeItem('dataLayer');
  }

  if(~window.location.href.indexOf(pageSlugs.labListing) && getParameterByName('country')) {

    // TODO replace with proper solution for persisting dataLayer
    // Copy dataLayer from session storage if user coming from main page
    if (document.referrer === `${hcpData.root_url}/${pageSlugs.mainPage}`) {
      const storedDataLayer = JSON.parse(window.sessionStorage.getItem('dataLayer'));
      if (storedDataLayer) window.dataLayer = storedDataLayer;  
    }
    }*/
    $(".chzn-select").val(getParameterByName('country')).trigger("chosen:updated");
    setTimeout(() => {
      searchLabs();
    }, 0);
  
});
